import { useState } from "react";
import { useParams } from "react-router";
import { Product } from "Hooks/useProducts/interface";
import { STATUS } from "Constants/Combos";
import {
  listProductsOnBudgetsCart,
  registerProductOnBudgetCart,
} from "Requests/Partners/Budgets";
import { createToast } from "Utils/toastFunc";
import { useQuery, useQueryClient } from "react-query";
import { BUDGETSTATUS } from "Constants/Budget";

export const useResultProductList = () => {
  const [modalViewInfoProduct, setModalViewInfoProduct] = useState(false);
  const [productDetailId, setProductDetailId] = useState<null | number>(null);
  const [modal, setModal] = useState({
    alerts: false,
    unavailable: false,
  });
  const [preparation, setPreparation] = useState("");

  const [preparationConfirmCallback, setPreparationConfirmCallback] = useState<{
    resolved: (() => void) | null;
    rejected: (() => void) | null;
  }>({ rejected: null, resolved: null });

  const { id } = useParams<{ id: string }>();

  const { data } = useQuery({
    queryFn: () => listProductsOnBudgetsCart(Number(id)),
    queryKey: ["budget-cart-items", id],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const client = useQueryClient();

  const blockInteraction = data?.status?.id === BUDGETSTATUS.converted;

  const openProductDetails = (productDetailIdd: number) => {
    setProductDetailId(productDetailIdd);
    setModalViewInfoProduct(true);
  };

  const closeModal = (modalClose: "alerts" | "unavailable") => {
    setModal((prev) => ({ ...prev, [modalClose]: false }));
  };

  const checkPreparation = (prep: string) => {
    return new Promise((resolve, reject) => {
      setModal((prev) => ({ ...prev, alerts: true }));
      setPreparation(prep);
      setPreparationConfirmCallback({
        rejected: () => reject("Adição cancelada"),
        resolved: () => resolve(""),
      });
    });
  };

  const proceedAddProduct = () => {
    if (preparationConfirmCallback.resolved)
      preparationConfirmCallback.resolved();
    setPreparationConfirmCallback({ rejected: null, resolved: null });
    closeModal("alerts");
  };

  const cancelAddProduct = () => {
    if (preparationConfirmCallback.rejected)
      preparationConfirmCallback.rejected();
    setPreparationConfirmCallback({ rejected: null, resolved: null });
    closeModal("alerts");
  };

  function goToTypeForm() {
    window.open("https://labiexames.typeform.com/to/ct1hTzh9");
    closeModal("unavailable");
  }

  const updateQueryCache = (oldData: undefined | any, newData: any) => {
    if (oldData) return newData;
  };

  const handleAddProduct = async (product: Product) => {
    try {
      if (product.status.id === STATUS.unavaliable) {
        setModal((prev) => ({ ...prev, unavailable: true }));
        return;
      }

      if (product.product_description?.budget_obs) {
        await checkPreparation(product.product_description.budget_obs);
      }

      if (data?.patient) {
        const payload = {
          budget_id: Number(id),
          patient_id: data?.patient?.id,
          item: {
            amount: 1,
            product_id: product.id,
          },
        };

        const response = await registerProductOnBudgetCart(payload);
        createToast("success", "Produto adicionado com sucesso");
        client.setQueryData(["budget-cart-items", id], (oldData: any) =>
          updateQueryCache(oldData, response)
        );
        return;
      }

      throw new Error("Sem informações do paciente");
    } catch (error: any) {
      if (error.response?.data?.errors?.length >= 1) {
        error.response.data.errors.forEach((error: string) =>
          createToast("error", error)
        );
      }
      if (error.message) {
        createToast("error", error.message);
      }
    }
  };

  const handleRemoveToCart = async (product: Product) => {
    try {
      if (data?.patient) {
        const payload = {
          budget_id: Number(id),
          patient_id: data?.patient?.id,
          item: {
            amount: 0,
            product_id: product.id,
          },
        };

        const response = await registerProductOnBudgetCart(payload);
        client.setQueryData(["budget-cart-items", id], (oldData: any) =>
          updateQueryCache(oldData, response)
        );
        createToast("success", "Produto removido com sucesso");

        return;
      }
      throw new Error("Sem informações do paciente");
    } catch (error: any) {
      if (error.message) {
        createToast("error", error.message);
      }
    }
  };

  return {
    proceedAddProduct,
    goToTypeForm,
    cancelAddProduct,
    openProductDetails,
    productDetailId,
    modalViewInfoProduct,
    handleRemoveToCart,
    handleAddProduct,
    closeModal,
    setModalViewInfoProduct,
    preparation,
    modal,
    data,
    blockInteraction,
  };
};
